import * as yup from 'yup';
import {
  AlcoholByVolumeBandType,
  ContainerType,
  CouplerType,
  GasType,
  GlassType,
  NozzleType,
  StatusType,
  StyleType,
  TapSealType
} from '../types';

export const createUpdateProductSchema = yup.object().shape({
  // Product Data
  name: yup.string().required().label('Name'),
  status: yup.mixed<StatusType>().oneOf(Object.values(StatusType)).required().label('Status type'),
  // Style Data
  style: yup
    .mixed<StyleType>()
    .oneOf(Object.values(StyleType))
    .optional()
    .transform((value, originalValue) => {
      return originalValue === '' || originalValue === null ? undefined : value;
    })
    .label('Style type'),
  alcoholByVolume: yup
    .number()
    .optional()
    .transform((value, originalValue) => {
      return originalValue === '' || originalValue === null ? undefined : value;
    })
    .label('Alcohol By Volume'),
  alcoholByVolumeBand: yup
    .mixed<AlcoholByVolumeBandType>()
    .oneOf(Object.values(AlcoholByVolumeBandType))
    .optional()
    .transform((value, originalValue) => {
      return originalValue === '' || originalValue === null ? undefined : value;
    })
    .label('ABV Band'),
  glutenFree: yup
    .boolean()
    .optional()
    .transform((value, originalValue) => {
      return originalValue === '' || originalValue === null ? undefined : value;
    })
    .label('Gluten Free'),
  vegan: yup
    .boolean()
    .optional()
    .transform((value, originalValue) => {
      return originalValue === '' || originalValue === null ? undefined : value;
    })
    .label('Vegan'),
  // Cellar Setup Data
  containerType: yup
    .mixed<ContainerType>()
    .oneOf(Object.values(ContainerType))
    .optional()
    .transform((value, originalValue) => {
      return originalValue === '' || originalValue === null ? undefined : value;
    })
    .label('Container type'),
  couplerType: yup
    .mixed<CouplerType>()
    .oneOf(Object.values(CouplerType))
    .optional()
    .transform((value, originalValue) => {
      return originalValue === '' || originalValue === null ? undefined : value;
    })
    .label('Coupler type'),
  gas1: yup
    .mixed<GasType>()
    .oneOf(Object.values(GasType))
    .optional()
    .transform((value, originalValue) => {
      return originalValue === '' || originalValue === null ? undefined : value;
    })
    .label('Gas 1 type'),
  gas2: yup
    .mixed<GasType>()
    .oneOf(Object.values(GasType))
    .optional()
    .transform((value, originalValue) => {
      return originalValue === '' || originalValue === null ? undefined : value;
    })
    .label('Gas 2 type'),
  co2vol: yup
    .number()
    .optional()
    .transform((value, originalValue) => {
      return originalValue === '' || originalValue === null ? undefined : value;
    })
    .label('CO2 Volume'),
  pumpRecommended: yup
    .boolean()
    .optional()
    .transform((value, originalValue) => {
      return originalValue === '' || originalValue === null ? undefined : value;
    })
    .label('Pump Recommended'),
  secondaryCoolingRecommended: yup
    .boolean()
    .optional()
    .transform((value, originalValue) => {
      return originalValue === '' || originalValue === null ? undefined : value;
    })
    .label('Secondary Cooling Recommended'),
  // Bar Setup Data
  nozzleType: yup
    .mixed<NozzleType>()
    .oneOf(Object.values(NozzleType))
    .optional()
    .transform((value, originalValue) => {
      return originalValue === '' || originalValue === null ? undefined : value;
    })
    .label('Nozzle type'),
  tapSealType: yup
    .mixed<TapSealType>()
    .oneOf(Object.values(TapSealType))
    .optional()
    .transform((value, originalValue) => {
      return originalValue === '' || originalValue === null ? undefined : value;
    })
    .label('Tap Seal type'),
  nozzleHolesCount: yup
    .number()
    .integer()
    .optional()
    .transform((value, originalValue) => {
      return originalValue === '' || originalValue === null ? undefined : value;
    })
    .label('Nozzle Holes Count'),
  nozzleHolesDiameter: yup
    .number()
    .optional()
    .transform((value, originalValue) => {
      return originalValue === '' || originalValue === null ? undefined : value;
    })
    .label('Nozzle Holes Diameter'),
  glassType: yup
    .mixed<GlassType>()
    .oneOf(Object.values(GlassType))
    .optional()
    .transform((value, originalValue) => {
      return originalValue === '' || originalValue === null ? undefined : value;
    })
    .label('Glass type'),
  glassNucleated: yup
    .boolean()
    .optional()
    .transform((value, originalValue) => {
      return originalValue === '' || originalValue === null ? undefined : value;
    })
    .label('Glass Nucleated'),
  // Dispense Specs Data
  dispenseSpeedMin: yup
    .number()
    .integer()
    .optional()
    .transform((value, originalValue) => {
      return originalValue === '' || originalValue === null ? undefined : value;
    })
    .label('Dispense Speed Min'),
  dispenseSpeedMax: yup
    .number()
    .integer()
    .optional()
    .transform((value, originalValue) => {
      return originalValue === '' || originalValue === null ? undefined : value;
    })
    .label('Dispense Speed Max'),
  dispenseTempMin: yup
    .number()
    .integer()
    .optional()
    .transform((value, originalValue) => {
      return originalValue === '' || originalValue === null ? undefined : value;
    })
    .label('Dispense Temp Min'),
  dispenseTempMax: yup
    .number()
    .integer()
    .optional()
    .transform((value, originalValue) => {
      return originalValue === '' || originalValue === null ? undefined : value;
    })
    .label('Dispense Temp Max'),
  headMin: yup
    .number()
    .integer()
    .optional()
    .transform((value, originalValue) => {
      return originalValue === '' || originalValue === null ? undefined : value;
    })
    .label('Head Min'),
  headMax: yup
    .number()
    .integer()
    .optional()
    .transform((value, originalValue) => {
      return originalValue === '' || originalValue === null ? undefined : value;
    })
    .label('Head Max'),
  settlingTime: yup
    .number()
    .integer()
    .optional()
    .transform((value, originalValue) => {
      return originalValue === '' || originalValue === null ? undefined : value;
    })
    .label('Settling Time'),
  // Relations
  brewerId: yup.string().required().label('Brewer')
});
